<template>
  <div class="pb_content" style="overflow: unset">
    <div
      class="pb_content_body"
      style="display: flex; min-height: 800px; position: relative"
    >
      <div class="pb_left">
        <div class="courseTitle">{{ courseDetail.title }}</div>
        <div class="ml">目录</div>
        <div class="cru_selectBox">
          <div v-for="(item, stageIndex) in navList" :key="stageIndex">
            <div class="blue_box_one" @click="get(stageIndex)">
              <div>第{{ stageIndex + 1 }}阶段</div>
              <div>{{ item.dyName }}</div>
            </div>
            <div class="twoChild" :class="{ navActive: item.isOpen }">
              <div
                class="navChild"
                v-for="(nav, navIndex) in item.task"
                :key="navIndex"
              >
                <div
                  class="navTask"
                  @click="openTask(stageIndex, navIndex, nav.id)"
                  :class="{ openTaskActive: nav.id == navId }"
                >
                  <div
                    class="vedioNav"
                    style="
                      margin: 0;
                      background: #aee3d2;
                      color: #32a77a;
                      width: 50px;
                      min-width: 50px;
                    "
                  >
                    任务{{ navIndex + 1 }}
                  </div>
                  <div class="navTaskname">{{ nav.taskName }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="body_student" style="width: 77%">
        <div class="new_top">
          <div class="before"></div>
          <div class="courseIndex">
            <div>第{{ courseType - 0 + 1 }}阶段</div>
            <div>{{ chapInfo.dyName }}</div>
          </div>
          <div
            style="position: absolute; right: 0"
            class="returnBtn"
            @click.stop="
              goTo(
                '/courseDetail?userid=' +
                  userid +
                  '&oid=' +
                  oid +
                  '&courseId=' +
                  id
              )
            "
          >
            返回
          </div>
        </div>

        <div
          class="study_top"
          v-for="(task, index) in chapInfoList[courseType].chapterInfo[0]
            .taskJson"
          :key="index"
        >
          <div class="checkbox">
            <div class="check" style="font-size: 25px" :id="task.id">
              {{ index + 1 }} {{ task.task }}
            </div>
          </div>
          <div
            class="project_box"
            style="margin-top: 15px; margin-bottom: 20px"
          >
            <div
              style="
                display: flex;
                flex-wrap: nowrap;
                flex-direction: column;
                position: relative;
              "
            >
              <div
                style="padding: 20px; line-height: 35px"
                v-if="task.taskDetail != ''"
              >
                <span style="color: #cbcbcb">任务描述</span>
                {{ task.taskDetail ? task.taskDetail : "暂无描述" }}
              </div>
            </div>
          </div>

          <!-- 有视频 -->
          <div class="student_head" v-if="vedio[index].length > 0">
            <div
              class="box_course"
              :class="vedio[index].length == 0 ? 'noVedio' : ''"
            >
              <div
                class="wheel"
                v-if="vedio.length && vedio[index] && vedio[index].length > 0"
              >
                <div class="workd_media" style="height: 100%">
                  <video-player
                    class="video-player vjs-custom-skin"
                    :playsinline="true"
                    :options="playerO[index]"
                    @play="onPlayerPlay($event)"
                    style="width: 90%; height: 100%; margin: 0 auto"
                  ></video-player>
                </div>
              </div>
              <div
                class="vedioList"
                :class="vedio[index].length == 0 ? 'listNoVedio' : ''"
                v-if="
                  (vedio.length && vedio[index] && vedio[index].length > 0) ||
                  (textList.length &&
                    textList[index] &&
                    textList[index].length > 0) ||
                  (chapToolList.length &&
                    chapToolList[index] &&
                    chapToolList[index].length > 0) ||
                  (lineList.length &&
                    lineList[index] &&
                    lineList[index].length > 0)
                "
              >
                <div
                  v-show="
                    vedio.length && vedio[index] && vedio[index].length > 0
                  "
                >
                  <div class="vedioNav">视频</div>
                  <div
                    class="media"
                    style="width: 160px; margin: 10px auto; position: relative"
                    v-for="(media, vedioIndex) in vedio[index]"
                    :key="vedioIndex + '1'"
                  >
                    <img
                      style="height: 90px; width: 160px"
                      :src="
                        media.cover != null && media.cover != ''
                          ? JSON.parse(media.cover).length > 0
                            ? JSON.parse(media.cover)[0].url
                            : mr
                          : mr
                      "
                      alt
                      @click="lookVedio(media.url)"
                    />
                    <div class="vedioName">{{ media.name }}</div>
                  </div>
                </div>
                <div
                  v-show="
                    textList.length &&
                    textList[index] &&
                    textList[index].length > 0
                  "
                  class="newNav"
                  v-for="(text, textIndex) in textList[index]"
                  :key="textIndex + '2'"
                >
                  <div class="vedioNav" style="width: 70px">富文本</div>
                  <div>
                    <div class="navText" @click="lookText(index, textIndex)">
                      {{ textList[index].length > 0 ? text.name : "" }}.doc
                    </div>
                  </div>
                </div>
                <div
                  v-show="
                    chapInfoList.length &&
                    chapToolList[index] &&
                    chapToolList[index].length > 0
                  "
                  class="newNav"
                  v-for="(tools, toolsIndex) in chapToolList[index]"
                  :key="toolsIndex + '3'"
                >
                  <div class="vedioNav">工具</div>
                  <div>
                    <div class="navText" @click="lookTools(index, toolsIndex)">
                      {{ chapToolList[index].length > 0 ? tools.name : "" }}
                    </div>
                  </div>
                </div>
                <div
                  v-show="
                    lineList.length &&
                    lineList[index] &&
                    lineList[index].length > 0
                  "
                  class="newNav"
                  v-for="(lines, lineIndex) in lineList[index]"
                  :key="lineIndex + '4'"
                >
                  <div class="vedioNav">链接</div>
                  <div>
                    <div class="navText">
                      <a
                        style="text-decoration: none; color: #000"
                        target="_Blank"
                        :href="'https://' + lines.url"
                        >{{ lines.url }}</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 没视频 -->
          <div class="student_head" v-else>
            <div class="box_course hangVedio">
              <div
                class="vedioList hangVedioList"
                v-if="
                  (vedio.length && vedio[index] && vedio[index].length > 0) ||
                  (textList.length &&
                    textList[index] &&
                    textList[index].length > 0) ||
                  (chapToolList.length &&
                    chapToolList[index] &&
                    chapToolList[index].length > 0) ||
                  (lineList.length &&
                    lineList[index] &&
                    lineList[index].length > 0)
                "
              >
                <div
                  v-show="
                    vedio.length && vedio[index] && vedio[index].length > 0
                  "
                >
                  <div class="vedioNav">视频</div>
                  <div
                    class="media"
                    style="width: 160px; margin: 10px auto; position: relative"
                    v-for="(media, vedioIndex) in vedio[index]"
                    :key="vedioIndex + '1'"
                  >
                    <img
                      style="height: 90px; width: 160px"
                      :src="
                        media.cover != null && media.cover != ''
                          ? JSON.parse(media.cover).length > 0
                            ? JSON.parse(media.cover)[0].url
                            : mr
                          : mr
                      "
                      alt
                      @click="lookVedio(media.url)"
                    />
                    <div class="vedioName">{{ media.name }}</div>
                  </div>
                </div>
                <div
                  v-show="
                    textList.length &&
                    textList[index] &&
                    textList[index].length > 0
                  "
                  class="newNav"
                  v-for="(text, textIndex) in textList[index]"
                  :key="textIndex + '2'"
                >
                  <div class="vedioNav" style="width: 70px">富文本</div>
                  <div>
                    <div class="noNavText" @click="lookText(index, textIndex)">
                      {{ textList[index].length > 0 ? text.name : "" }}.doc
                    </div>
                  </div>
                </div>
                <div
                  v-show="
                    chapInfoList.length &&
                    chapToolList[index] &&
                    chapToolList[index].length > 0
                  "
                  class="newNav"
                  v-for="(tools, toolsIndex) in chapToolList[index]"
                  :key="toolsIndex + '3'"
                >
                  <div class="vedioNav">工具</div>
                  <div>
                    <div
                      class="noNavText"
                      @click="lookTools(index, toolsIndex)"
                    >
                      {{ chapToolList[index].length > 0 ? tools.name : "" }}
                    </div>
                  </div>
                </div>
                <div
                  v-show="
                    lineList.length &&
                    lineList[index] &&
                    lineList[index].length > 0
                  "
                  class="newNav"
                  v-for="(lines, lineIndex) in lineList[index]"
                  :key="lineIndex + '4'"
                >
                  <div class="vedioNav">链接</div>
                  <div>
                    <div class="noNavText">
                      <a
                        style="text-decoration: none; color: #000"
                        target="_Blank"
                        :href="'https://' + lines.url"
                        >{{ lines.url }}</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="student_body">
            <div
              class="project_box"
              v-if="file.length && file[index] && file[index].length > 0"
            >
              <div class="queTop">
                <div class="question" style="width: 30px;margin-top: 5px;">
                  <img src="../assets/icon/fileIcon.png" alt />
                </div>
                <div class="queTitle">
                  <div>附件</div>
                </div>
              </div>
              <div class="filebox" style="width: 100%">
                <div
                  class="file"
                  v-for="(f, fileIndex) in file[index]"
                  :key="fileIndex"
                  @click="downFile(f, fileIndex)"
                >
                  <img :src="require('../assets/file.png')" alt />
                  <div>{{ f.name }}</div>
                </div>
              </div>
              <div class="upFile" v-if="type == 3">提交</div>
            </div>
            <div
              class="project_box"
              v-if="
                task.toolChoose[0].tool &&
                task.toolChoose[0].tool.length &&
                task.toolChoose[0].tool.length > 0
              "
            >
              <div class="queTop">
                <div class="question" style="width: 30px">
                  <img src="../assets/icon/toolIcon.png" alt />
                </div>
                <div class="queTitle">
                  <div>工具</div>
                </div>
              </div>
              <div class="toolHeng2" style="position: relative">
                <div
                  class="filebox"
                  style="flex-wrap: nowrap; margin: 0 20px"
                  v-for="(tool, toolIndex) in task.toolChoose"
                  :key="toolIndex"
                >
                  <div class="tooldetail" v-if="tool.toolDetail != ''">
                    <!-- <div class="toolTitle">工具描述</div> -->
                    <div style="line-height: 35px; width: 85%">
                      {{ tool.toolDetail }}
                    </div>
                  </div>
                  <div>
                    <!-- v-for="(itemTool, indexTool) in toolTypeList"
                    :key="indexTool"-->

                    <!-- <div class="iframeBox">
                      <div
                        class="addPoint isBorder"
                        v-for="(tooC, toolCIndex) in tool.tool"
                        :key="toolCIndex"
                      >
                        <div v-if="tooC == 1" style="border: 1px soild #ccc">
                          <div
                            class="iframeName"
                          >
                            电子白板
                          </div>
                          <iframe
                            src="https://iwb.cocorobo.cn/"
                            ref="whiteBoard"
                          ></iframe>
                        </div>
                      </div>
                    </div> -->
                    <div class="noiframeBox">
                      <div
                        class="addPoint"
                        v-for="(tooC, toolCIndex) in tool.tool"
                        :key="toolCIndex"
                      >
                        <div v-if="tooC == 1">
                          <img
                            src="../assets/icon/secondToolList/whiteBoard.png"
                            alt
                            @click="addTools(tooC, toolIndex, index)"
                          />
                          <div style="margin: 5px 0">电子白板</div>
                        </div>
                        <div v-if="tooC == 3">
                          <img
                            src="../assets/icon/secondToolList/mindMapping.png"
                            alt
                            @click="addTools(tooC, toolIndex, index)"
                          />
                          <div style="margin: 5px 0">思维导图</div>
                        </div>
                        <div v-if="tooC == 6">
                          <img
                            src="../assets/icon/secondToolList/doc.png"
                            alt
                            @click="addTools(tooC, toolIndex, index)"
                          />
                          <div style="margin: 5px 0">协同文档</div>
                        </div>
                        <div v-if="tooC == 7">
                          <img
                            src="../assets/icon/secondToolList/mindNetwork.png"
                            alt
                            @click="addTools(tooC, toolIndex, index)"
                          />
                          <div style="margin: 5px 0">思维网格</div>
                        </div>
                        <div v-if="tooC == 8">
                          <img
                            src="../assets/icon/secondToolList/library.png"
                            alt
                            @click="addTools(tooC, toolIndex, index)"
                          />
                          <div style="margin: 5px 0">素材库</div>
                        </div>
                        <div v-if="tooC == 17">
                          <img
                            src="../assets/icon/secondToolList/library.png"
                            alt
                            @click="addTools(tooC, toolIndex, index)"
                          />
                          <div style="margin: 5px 0">学习资料</div>
                        </div>
                        <div v-if="tooC == 2">
                          <img
                            @click="addTools(tooC, toolIndex, index)"
                            src="../assets/icon/secondToolList/note.png"
                            alt
                          />
                          <div style="margin: 5px 0">便签</div>
                        </div>
                        <div v-if="tooC == 4">
                          <img
                            @click="addTools(tooC, toolIndex, index)"
                            src="../assets/icon/thirdToolList/ask.png"
                            alt
                          />
                          <div style="margin: 5px 0">问卷调查</div>
                        </div>
                        <div v-if="tooC == 5">
                          <img
                            @click="addTools(tooC, toolIndex, index)"
                            src="../assets/icon/thirdToolList/score.png"
                            alt
                          />
                          <div style="margin: 5px 0">量规评分</div>
                        </div>
                        <div v-if="tooC == 10">
                          <img
                            @click="addTools(tooC, toolIndex, index)"
                            src="../assets/icon/thirdToolList/time.png"
                            alt
                          />
                          <div style="margin: 5px 0">倒计时</div>
                        </div>
                        <div v-if="tooC == 15">
                          <img
                            @click="addTools(tooC, toolIndex, index)"
                            src="../assets/icon/thirdToolList/answer.png"
                            alt
                          />
                          <div style="margin: 5px 0">问答工具</div>
                        </div>
                        <div v-if="tooC == 18">
                          <img
                            @click="addTools(tooC, toolIndex, index)"
                            src="../assets/icon/thirdToolList/trainPlatform.png"
                            alt
                          />
                          <div style="margin: 5px 0">训练服务器</div>
                        </div>
                        <!-- <div v-if="tooC == 16">
                        <img
                          @click="addTools(tooC, toolIndex)"
                          src="../assets/icon/thirdToolList/work.png"
                          alt
                        />
                        <div style="margin: 5px 0">作业提交</div>
                        </div>-->
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="upload_toolBtn" @click="addImg($event)">
                  上传文件
                  <input
                    type="file"
                    accept="image/png, image/gif, image/jpeg"
                    style="display: none"
                    @change="beforeUpload1($event, 2, index)"
                  />
                </div> -->
              </div>
            </div>
            <!-- <div
              class="project_box"
              style="margin-top: 15px; padding-bottom: 30px"
            >
              <div
                style="
                  display: flex;
                  flex-wrap: nowrap;
                  flex-direction: column;
                  position: relative;
                "
              >
                <div class="queTop">
                  <div class="question">
                    <img src="../assets/icon/homeWork.png" alt="" />
                  </div>
                  <div class="queTitle">
                    <div>作业提交<span>(提交图文视频等)</span></div>
                    <div>：任务：{{ task.task }}</div>
                  </div>
                </div>
                <div class="ediBottom">
                  <div
                    class="addEditor"
                    style="margin-top: 23px"
                    @click="openAddWork"
                    v-if="!isNoHomeWork"
                  >
                    选择文件
                  </div>
                  <div
                    class="addEditor"
                    style="margin-top: 23px"
                    @click="openAddWork"
                    v-else
                  >
                    已提交
                  </div>
                </div>
              </div>
            </div>-->
          </div>
        </div>
        <el-dialog
          title="提交实践作业"
          :visible.sync="dialogVisible"
          :append-to-body="true"
          width="500px"
          :before-close="handleClose"
          class="dialog_change"
        >
          <div class="first">
            <div>作业名称:</div>
            <div>{{ chapInfo.dyName }}</div>
          </div>
          <div style="font-size: 20px; margin-bottom: 10px">上传作业</div>
          <el-input
            type="textarea"
            resize="none"
            rows="7"
            placeholder="输入文字描述..."
            v-model="studyJuri[0].content"
          ></el-input>
          <div class="marginT">
            <div>上传图片</div>
            <div class="chapter_add" @click="addImg($event)">
              <div class="up_photo">
                <img src="../assets/photo.png" alt />
              </div>
              <input
                type="file"
                accept="image/png, image/gif, image/jpeg"
                style="display: none"
                @change="beforeUpload1($event, 1)"
              />
            </div>
            <div
              class="chapter_add"
              style="
                display: flex;
                width: 100%;
                flex-direction: row;
                flex-wrap: wrap;
                justify-content: flex-start;
              "
              v-if="studyJuri[0].cover.length > 0"
            >
              <div
                v-for="(c, cIndex) in studyJuri[0].cover"
                :key="cIndex"
                class="upCover"
              >
                <img :src="c.url != null && c.url != '' ? c.url : mr" alt />
                <span class="picName">{{ c.name }}</span>

                <div class="deleteWord" @click="clean(1)">
                  <img src="../assets/icon/delete.png" alt />
                </div>
              </div>
            </div>
          </div>
          <div class="marginT">
            <div>上传视频</div>
            <div class="chapter_add" @click="addImg($event)">
              <div class="up_photo">
                <img src="../assets/vidio.png" alt />
              </div>
              <input
                type="file"
                accept="video/mp4, video/quicktime, video/x-msvideo"
                style="display: none"
                @change="beforeUpload2($event, 2)"
              />
            </div>
            <div
              class="chapter_add"
              style="
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                width: 100%;
                justify-content: flex-start;
              "
              v-if="studyJuri[0].upVedio.length > 0"
            >
              <div
                style="
                  width: 100%;
                  display: flex;
                  flex-direction: row;
                  flex-wrap: wrap;
                  align-content: flex-start;
                  justify-content: flex-start;
                  align-items: center;
                "
              >
                <div
                  class="uploadVedio isAddThings"
                  v-for="(v, vIndex) in studyJuri[0].upVedio"
                  :key="vIndex"
                >
                  <img src="../assets/uploadMp4.png" alt />
                  <span>{{ v.name }}</span>
                  <div class="deleteWord" @click="clean(2)">
                    <img src="../assets/icon/delete.png" alt />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="upload_send" @click="addWork">提交</div>
        </el-dialog>
      </div>
    </div>
    <div v-if="proVisible" class="mask">
      <div class="progressBox">
        <div class="lbox">
          <img src="../assets/loading.gif" />上传中，请稍后
        </div>
        <el-progress
          :text-inside="true"
          :stroke-width="20"
          :percentage="progress"
          style="width: 80%"
        ></el-progress>
      </div>
    </div>
    <el-dialog :visible.sync="pictureDialog" size="tiny">
      <img width="100%" :src="dialogImageUrl" alt />
    </el-dialog>
    <el-dialog
      title="查看问卷调查"
      :visible.sync="dialogVisible5"
      :append-to-body="true"
      width="800px"
      :before-close="handleClose"
      class="dialog_diy"
    >
      <div>
        <div
          class="a_add_title"
          style="
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
          "
        >
          <div style="margin-right: 20px; font-size: 20px">问卷标题:</div>
          <div style="font-size: 20px">{{ askJson.askTitle }}</div>
        </div>
        <div class="a_addBox">
          <div style="font-size: 16px; color: #c7c7c7">问卷内容</div>
          <div
            class="a_add_box"
            v-for="(item1, index1) in askJson.askCount"
            :key="index1"
          >
            <div class="a_add_head">
              <div style="display: flex">
                {{ index1 + 1 + "、" }}
                <div>问卷题目：{{ askJson.askJson[index1].askstitle }}</div>
              </div>
            </div>
            <div class="a_add_body">
              <div class="a_add_input">
                <el-radio-group v-model="radio[index1]">
                  <el-radio
                    v-for="(item2, checkIndex) in askJson.askJson[index1]
                      .checkList"
                    :key="checkIndex"
                    :label="checkIndex"
                    class="redioStyle"
                    >{{ item2 }}</el-radio
                  >
                </el-radio-group>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible5 = false">取 消</el-button>
        <el-button type="primary" @click="addStudentAsk">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="查看富文本"
      :visible.sync="dialogVisible1"
      :append-to-body="true"
      width="500px"
      :before-close="handleClose"
      class="dialog_diy textCss"
    >
      <el-form style="font-size: 20px">
        <el-form-item label="文本标题" class="textTitle">
          <div style="font-size: 20px">{{ text.name }}</div>
        </el-form-item>
        <div>富文本内容</div>
        <div
          v-html="text.url"
          style="font-size: 18px; padding: 40px 0 0 0"
        ></div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible1 = false"
          >确定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="文件预览"
      :visible.sync="dialogVisible3"
      width="50%"
      :before-close="handleClose"
      class="dialog_diy"
    >
      <iframe
        :src="pptImgUrl"
        frameborder="0"
        width="100%"
        height="600"
      ></iframe>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible4"
      :append-to-body="true"
      width="800px"
      :before-close="handleClose"
      class="dialog_diy notice"
    >
      <div>此功能暂未开放！</div>
      <el-button type="primary" @click="dialogVisible4 = false">确定</el-button>
    </el-dialog>
    <el-dialog
      title="问答"
      :visible.sync="answerDialogVisible"
      :append-to-body="true"
      width="800px"
      :before-close="handleClose"
      class="dialog_diy"
    >
      <div>
        <div
          style="
            display: flex;
            flex-wrap: nowrap;
            flex-direction: column;
            position: relative;
          "
        >
          <div class="queTop">
            <div class="question">
              <img src="../assets/icon/question.png" alt />
            </div>
            <div class="queTitle">
              <div>提问：</div>
              <div>{{ answerQ }}</div>
            </div>
          </div>
          <div class="ediBottom">
            <textarea
              rows="6"
              class="binfo_input"
              cols
              style="width: 95%; height: 120px"
              v-model="questionAnswer"
            ></textarea>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="answerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addQuestion">提 交</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="倒计时"
      :visible.sync="timeDialogVisible"
      :append-to-body="true"
      width="800px"
      :before-close="handleClose"
      class="dialog_diy"
    >
      <div>
        <Time v-if="timeDialogVisible"></Time>
      </div>
      <div slot="footer">
        <el-button @click="timeDialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import "../common/aws-sdk-2.235.1.min.js";
import EditorBar from "../components/tools/wangEnduit.vue";
import Time from "../components/tools/time.vue";
export default {
  components: { EditorBar, Time },
  data() {
    return {
      dialogVisible: false,
      id: this.$route.query.courseId,
      userid: this.$route.query.userid,
      courseTypeLine: this.$route.query.type,
      oid: this.$route.query.oid,
      courseType: 0,
      pptImgUrl: "",
      type: 1,
      vedio: [],
      text: [],
      textList: [],
      line: [],
      lineList: [],
      chapTools: [],
      chapToolList: [],
      file: [],
      upToolImg: "",
      rateList: {
        ca: 0,
      },
      rateParams: [],
      colors: ["#000", "#000", "#000"],
      studyJuri: [
        {
          content: "",
          cover: [],
          upVedio: [],
          upFile: [],
        },
      ],
      mr: require("../assets/vedioPic.png"),
      courseDetail: {},
      chapInfo: [],
      chapInfoList: [],
      taskCount: 0,
      imgList: [],
      noImgList: [],
      navId: "",
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4", //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目   || "video/ogg"|| "video/webm"
            src: "", //url地址require("../../assets/media/aaa.mp4")
          },
        ],
        // poster: require("../../assets/tu31.png"), //你的封面地址
        // poster: dataRes.imgUrl, //你的封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, //当前时间和持续时间的分隔符
          durationDisplay: true, //显示持续时间
          remainingTimeDisplay: false, //是否显示剩余时间功能
          fullscreenToggle: true, //全屏按钮
        },
      },
      playerO: {},
      noneBtnImg: false,
      proVisible: false,
      progress: 0,
      questionAnswer: "",
      answerQ: "", //问答标题
      wbCount: 0,
      wordCount: 0,
      mindCount: 0,
      askCount: 0,
      noteCount: 0,
      mindNetWorkCount: 0,
      libraryCount: 0,
      workCount: 0,
      timeCount: 0,
      answerCount: 0,
      trainCount: 0,
      dialogImageUrl: "",
      pictureDialog: false,
      toolTypeList: [],
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      dialogVisible4: false,
      isNoHomeWork: false,
      dialogVisible5: false,
      answerDialogVisible: false,
      timeDialogVisible: false,
      radio: [],
      isAsk: false,
      askJson: {
        askCount: 1,
        askTitle: "",
        askJson: [{ askstitle: "", askItem: 1, checkList: [] }],
      },
      askList: [],
      answerList: [],
      navList: [],
    };
  },
  methods: {
    change(val) {
      console.log(val);
    },
    goTo(path) {
      this.$router.push(path);
    },
    handlePictureCardPreview(url) {
      this.dialogImageUrl = url;
      this.pictureDialog = true;
    },
    clean(type) {
      if (type == 1) {
        this.studyJuri[0].cover.splice(0, 1);
      } else if (type == 2) {
        this.studyJuri[0].upVedio.splice(0, 1);
      } else {
        this.studyJuri[0].upFile.splice(0, 1);
      }
    },
    handleClose(done) {
      done();
    },
    imgChange(file, fileList, type) {
      if (type == 1) {
        var _tmp = this.studyJuri[0].cover;
      } else if (type == 2) {
        var _tmp = this.studyJuri[0].upVedio;
      } else {
        var _tmp = this.studyJuri[0].upFile;
      }
      this.noneBtnImg = _tmp.length >= 1;
    },
    addImg(e) {
      var el = e.currentTarget;
      el.getElementsByTagName("input")[0].click();
    },
    addCourseWorks(i) {
      let params = [
        {
          uid: this.userid,
          cid: this.id,
          stage: this.courseType,
          task: i,
          content: this.upToolImg,
          type: 1,
        },
      ];
      this.ajax
        .post(this.$store.state.api + "addCourseWorks", params)
        .then((res) => {
          this.$message({
            message: "提交成功",
            type: "success",
          });
          this.upToolImg = "";
        })
        .catch((err) => {
          this.$message.error("提交失败");
          console.error(err);
        });
    },
    beforeUpload1(event, type, i) {
      var file = event.target.files[0];
      var credentials = {
        accessKeyId: "AKIATLPEDU37QV5CHLMH",
        secretAccessKey: "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",
      }; //秘钥形式的登录上传
      window.AWS.config.update(credentials);
      window.AWS.config.region = "cn-northwest-1"; //设置区域

      var bucket = new window.AWS.S3({ params: { Bucket: "ccrb" } }); //选择桶
      var _this = this;
      _this.progress = 0;
      _this.proVisible = true;

      if (file) {
        var params = {
          Key:
            file.name.split(".")[0] +
            new Date().getTime() +
            "." +
            file.name.split(".")[1],
          ContentType: file.type,
          Body: file,
          "Access-Control-Allow-Credentials": "*",
          ACL: "public-read",
        }; //key可以设置为桶的相抵路径，Body为文件， ACL最好要设置
        var options = {
          partSize: 2048 * 1024 * 1024,
          queueSize: 2,
          leavePartsOnError: true,
        };
        bucket
          .upload(params, options)
          .on("httpUploadProgress", function (evt) {
            //这里可以写进度条
            // console.log("Uploaded : " + parseInt((evt.loaded * 80) / evt.total) + '%');
            _this.progress = parseInt((evt.loaded * 80) / evt.total);
          })
          .send(function (err, data) {
            _this.progress = 100;
            setTimeout(() => {
              _this.proVisible = false;
            }, 1000);
            if (err) {
              var a = _this.$refs.upload1.uploadFiles;
              a.splice(a.length - 1, a.length);
              _this.$message.error("上传失败");
            } else {
              if (type == 1) {
                _this.studyJuri[0].cover.push({
                  name: file.name,
                  url: data.Location,
                  uid: file.uid,
                });
                _this.imgChange(null, null, type);
              } else if (type == 2) {
                _this.upToolImg = data.Location;
                _this.imgChange(null, null, type);
                _this.addCourseWorks(i);
              }
              _this.imgChange(null, null, type);
              console.log(data.Location);
            }
          });
      }
    },
    beforeUpload2(event, type) {
      var file = event.target.files[0];
      var credentials = {
        accessKeyId: "AKIATLPEDU37QV5CHLMH",
        secretAccessKey: "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",
      }; //秘钥形式的登录上传
      window.AWS.config.update(credentials);
      window.AWS.config.region = "cn-northwest-1"; //设置区域

      var bucket = new window.AWS.S3({ params: { Bucket: "ccrb" } }); //选择桶
      var _this = this;
      _this.progress = 0;
      _this.proVisible = true;

      if (file) {
        var params = {
          Key:
            file.name.split(".")[0] +
            new Date().getTime() +
            "." +
            file.name.split(".")[1],
          ContentType: file.type,
          Body: file,
          "Access-Control-Allow-Credentials": "*",
          ACL: "public-read",
        }; //key可以设置为桶的相抵路径，Body为文件， ACL最好要设置
        var options = {
          partSize: 2048 * 1024 * 1024,
          queueSize: 2,
          leavePartsOnError: true,
        };
        bucket
          .upload(params, options)
          .on("httpUploadProgress", function (evt) {
            //这里可以写进度条
            // console.log("Uploaded : " + parseInt((evt.loaded * 80) / evt.total) + '%');
            _this.progress = parseInt((evt.loaded * 80) / evt.total);
          })
          .send(function (err, data) {
            _this.progress = 100;
            setTimeout(() => {
              _this.proVisible = false;
            }, 1000);
            if (err) {
              var a = _this.$refs.upload1.uploadFiles;
              a.splice(a.length - 1, a.length);
              _this.$message.error("上传失败");
            } else {
              if (type == 2) {
                _this.studyJuri[0].upVedio.push({
                  name: file.name,
                  url: data.Location,
                  uid: file.uid,
                });
                _this.imgChange(null, null, type);
              } else if (type == 3) {
                _this.studyJuri[0].upFile.push({
                  name: file.name,
                  url: data.Location,
                  uid: file.uid,
                });
                _this.imgChange(null, null, type);
              }
              console.log(data.Location);
            }
          });
      }
    },
    openTask(s, n, i) {
      this.courseType = s;
      this.navId = i;
      this.isNoHomeWork = false;
      (this.studyJuri = [
        {
          content: "",
          cover: [],
          upVedio: [],
          upFile: [],
        },
      ]),
        (this.radio = []);
      setTimeout(() => {
        let a = document.getElementById(i);
        if (a.offsetTop - 110 == 0) {
          window.scrollTo(0, 0);
        } else {
          window.scrollTo(0, a.offsetTop);
        }
      }, 0);

      this.getHomeWork();
      this.getCourseDetail();
    },

    get(i) {
      this.navList[i].isOpen = !this.navList[i].isOpen;
    },
    addQuestion() {
      this.answerList.push({
        answerTitle: this.answerQ,
        answer: this.questionAnswer,
      });
      let params = [
        {
          uid: this.userid,
          cid: this.id,
          stage: this.courseType,
          task: this.taskCount,
          content: JSON.stringify(this.answerList),
          type: 3,
        },
      ];
      this.ajax
        .post(this.$store.state.api + "addCourseWorks", params)
        .then((res) => {
          this.$message({
            message: "提交成功",
            type: "success",
          });
          this.answerList = [];
          this.answerDialogVisible = false;
        })
        .catch((err) => {
          this.$message.error("提交失败");
          console.error(err);
        });
    },
    getCourseDetail() {
      const loading = this.$loading.service({
        background: "rgba(255, 255, 255, 0.7)",
        target: document.querySelector(".student_table"),
      });
      var t = this.courseType;
      let params = {
        courseId: this.id,
      };
      this.ajax
        .get(this.$store.state.api + "selectCourseDetail", params)
        .then((res) => {
          loading.close();
          var a = JSON.parse(res.data[0][0].chapters)[t].chapterInfo[0]
            .taskJson;
          var b = [
            "AVI",
            "NAVI",
            "MPEG",
            "ASF",
            "MOV",
            "WMV",
            "3GP",
            "RM",
            "RMVB",
            "FLV",
            "F4V",
            "H.264",
            "H.265",
            "REAL VIDEO",
            "MKV",
            "WebM",
            "HDDVD",
            "MP4",
            "MPG",
            "M4V",
            "MGV",
            "OGV",
            "QTM",
            "STR",
            "AMC",
            "DVX",
            "EVO",
            "DAT",
            "OGG",
            "OGM",
          ];
          for (var i = 0; i < a.length; i++) {
            var c = a[i].chapterData;
            this.vedio[i] = [];
            this.textList[i] = [];
            this.lineList[i] = [];
            this.chapToolList[i] = [];
            this.file[i] = [];
            for (var j = 0; j < c.length; j++) {
              if (c[j].type == 7) {
                this.chapToolList[i].push(c[j]);
              } else if (c[j].type == 8) {
                this.lineList[i].push(c[j]);
              } else if (c[j].type == 6) {
                this.textList[i].push(c[j]);
              } else {
                if (
                  b.indexOf(
                    c[j].url
                      .split(".")
                      [c[j].url.split(".").length - 1].toLocaleUpperCase()
                  ) != -1
                ) {
                  this.vedio[i].push(c[j]);
                } else {
                  this.file[i].push(c[j]);
                }
              }
            }
            var d = JSON.parse(JSON.stringify(this.playerOptions));
            d.sources[0].src =
              this.vedio[i].length > 0 ? this.vedio[i][0].url : this.mr;
            this.playerO[i] = d;
          }
          this.courseDetail = res.data[0][0];
          this.chapInfo = JSON.parse(this.courseDetail.chapters)[t];
          this.chapInfoList = JSON.parse(this.courseDetail.chapters);
          if (this.navList.length == 0) {
            this.navList = [];
            for (var l = 0; l < this.chapInfoList.length; l++) {
              var q = this.chapInfoList[l].dyName;
              var w = this.chapInfoList[l].chapterInfo[0].taskJson;
              var e;
              this.navList.push({
                dyName: q,
                isOpen: l === 0 ? true : false,
                task: [],
              });
              for (var r = 0; r < w.length; r++) {
                e = w[r].task;
                this.navList[l].task.push({ taskName: e, id: l + "-" + r });
                this.navId = this.navId ? this.navId : l + "-" + r;
              }
            }
          }
          for (var l = 0; l < this.chapInfoList.length; l++) {
            var w = this.chapInfoList[l].chapterInfo[0].taskJson;
            for (var m = 0; m < w.length; m++) {
              w[m].id = l + "-" + m;
            }
          }

          this.$nextTick(function () {
            setTimeout(() => {
              for (
                var i = 0;
                i < document.getElementsByClassName("video-player").length;
                i++
              ) {
                var a =
                  document.getElementsByClassName("video-player")[i]
                    .offsetHeight;
                document.getElementsByClassName("vedioList")[i].style.height =
                  a + "px";
              }
            }, 500);
          });
        })
        .catch((err) => {
          loading.close();
          console.error(err);
        });
    },
    getHomeWork() {
      let params = {
        cid: this.id,
        stage: this.courseType,
        task: this.taskCount,
        uid: this.userid,
      };
      this.ajax
        .get(this.$store.state.api + "selectWork", params)
        .then((res) => {
          if (res.data[0].length > 0) {
            this.studyJuri = JSON.parse(res.data[0][0].content);
            this.isNoHomeWork = true;
          } else {
            console.log("没有作业");
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    isAssetTypeAnImage(ext) {
      return (
        [
          "png",
          "jpg",
          "jpeg",
          "bmp",
          "gif",
          "webp",
          "psd",
          "svg",
          "tiff",
        ].indexOf(ext) !== -1
      );
    },
    switchVideo(media) {
      this.playerO = {};
      this.playerOptions.poster = "";
      this.playerOptions.sources[0].src = media;
      this.playerO = this.playerOptions;
    },
    onPlayerPlay() {},
    lookVedio(u) {
      this.playerOptions.sources[0].src = u;
      this.playerO = this.playerOptions;
    },
    lookText(i, t) {
      this.text = this.textList[i][t];
      this.dialogVisible1 = true;
    },
    lookTools(i, t) {
      this.chapTools = this.chapToolList[i][t];
      this.dialogVisible2 = true;
    },
    downFile(f, i) {
      var a = ["PPT", "PPTX", "PDF", "XLSX", "XLS", "DOC", "DOCX"];
      if (
        a.indexOf(
          f.url.split(".")[f.url.split(".").length - 1].toLocaleUpperCase()
        ) != -1
      ) {
        this.pptImgUrl =
          "https://view.officeapps.live.com/op/view.aspx?src=" + f.url;
        this.dialogVisible3 = true;
      } else {
        window.open(this.file[i].url);
      }
    },
    downFileList(i) {
      window.open(this.noImgList[i].url);
    },
    openAddWork() {
      this.dialogVisible = true;
    },
    addStudentAsk() {
      this.askList.push({ askJson: this.askJson, anwer: this.radio.join(",") });
      let params = [
        {
          uid: this.userid,
          cid: this.id,
          stage: this.courseType,
          task: this.taskCount,
          content: JSON.stringify(this.askList),
          type: 2,
        },
      ];
      this.ajax
        .post(this.$store.state.api + "addCourseWorks", params)
        .then((res) => {
          this.$message({
            message: "提交成功",
            type: "success",
          });
          this.askList = [];
          this.dialogVisible5 = false;
        })
        .catch((err) => {
          this.$message.error("提交失败");
          console.error(err);
        });
    },
    addWork() {
      if (this.studyJuri[0].content == "") {
        this.$message.error("请将信息填写完整");
        return;
      } else if (this.studyJuri[0].cover.length == 0) {
        this.$message.error("请将信息填写完整");
        return;
      } else if (this.studyJuri[0].upVedio.length == 0) {
        this.$message.error("请将信息填写完整");
        return;
      }
      if (this.isNoHomeWork) {
        this.$confirm(
          "您已经提交了该作业了，如果您再提交将覆盖上次提交的作业！",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => {
            let params = [
              {
                uid: this.userid,
                cid: this.id,
                stage: this.courseType,
                task: this.taskCount,
                content: JSON.stringify(this.studyJuri),
              },
            ];
            this.ajax
              .post(this.$store.state.api + "addWorks", params)
              .then((res) => {
                this.$message({
                  message: "提交成功",
                  type: "success",
                });
                this.isNoHomeWork = true;
                this.dialogVisible = false;
              })
              .catch((err) => {
                this.$message.error("提交失败");
                console.error(err);
              });
          })
          .catch(() => {});
      } else {
        let params = [
          {
            uid: this.userid,
            cid: this.id,
            stage: this.courseType,
            task: this.taskCount,
            content: JSON.stringify(this.studyJuri),
          },
        ];
        this.ajax
          .post(this.$store.state.api + "addWorks", params)
          .then((res) => {
            this.$message({
              message: "提交成功",
              type: "success",
            });
            this.isNoHomeWork = true;
            this.dialogVisible = false;
          })
          .catch((err) => {
            this.$message.error("提交失败");
            console.error(err);
          });
      }
    },
    selectCount() {
      let params = {
        cid: this.id,
        chid: this.courseType,
        uid: this.userid,
      };
      this.ajax
        .get(this.$store.state.api + "selectToolsCount", params)
        .then((res) => {
          for (var i = 0; i < res.data[0].length; i++) {
            if (res.data[0][i].tools == 1) {
              this.wbCount = res.data[0][i].count;
            } else if (res.data[0][i].tools == 2) {
              this.wordCount = res.data[0][i].count;
            } else if (res.data[0][i].tools == 3) {
              this.mindCount = res.data[0][i].count;
            } else if (res.data[0][i].tools == 4) {
              this.askCount = res.data[0][i].count;
            } else if (res.data[0][i].tools == 6) {
              this.noteCount = res.data[0][i].count;
            } else if (res.data[0][i].tools == 7) {
              this.mindNetWorkCount = res.data[0][i].count;
            } else if (res.data[0][i].tools == 8) {
              this.libraryCount = res.data[0][i].count;
            } else if (res.data[0][i].tools == 16) {
              this.workCount = res.data[0][i].count;
            } else if (res.data[0][i].tools == 10) {
              this.timeCount = res.data[0][i].count;
            } else if (res.data[0][i].tools == 15) {
              this.answerCount = res.data[0][i].count;
            } else if (res.data[0][i].tools == 18) {
              this.trainCount = res.data[0][i].count;
            }
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    addTools(t, i, index) {
      var a = 0;
      this.taskCount = index;
      if (t == 1) {
        if (this.wbCount > 0) {
          this.updateCount(this.wbCount, t);
        } else {
          this.wbCount++;
          a = this.wbCount;
          this.toolsCount(a, t);
        }
        window.parent.postMessage({ tools: "1" }, "*");
      } else if (t == 2) {
        if (this.wordCount > 0) {
          this.updateCount(this.wordCount, t);
        } else {
          this.wordCount++;
          a = this.wordCount;
          this.toolsCount(a, t);
        }
        window.parent.postMessage({ tools: "2" }, "*");
      } else if (t == 3) {
        if (this.mindCount > 0) {
          this.updateCount(this.mindCount, t);
        } else {
          this.mindCount++;
          a = this.mindCount;
          this.toolsCount(a, t);
        }
        window.parent.postMessage({ tools: "3" }, "*");
      } else if (t == 4) {
        if (this.askCount > 0) {
          this.updateCount(this.askCount, t);
        } else {
          this.askCount++;
          a = this.askCount;
          this.toolsCount(a, t);
        }
        if (!this.dialogVisible2) {
          this.askJson.askJson =
            this.chapInfo.chapterInfo[0].taskJson[index].toolChoose[i].askJson;
          this.askJson.askTitle =
            this.chapInfo.chapterInfo[0].taskJson[index].toolChoose[i].askTitle;
          this.askJson.askCount =
            this.chapInfo.chapterInfo[0].taskJson[index].toolChoose[i].askCount;
        } else {
          this.askJson.askJson = this.chapTools.askJson.askJson;
          this.askJson.askTitle = this.chapTools.askJson.askTitle;
          this.askJson.askCount = this.chapTools.askJson.askCount;
        }
        this.dialogVisible5 = true;
        // window.parent.postMessage({ tools: "4" }, "*");
      } else if (t == 5) {
        if (this.scoreCount > 0) {
          this.updateCount(this.scoreCount, t);
        } else {
          this.scoreCount++;
          a = this.scoreCount;
          this.toolsCount(a, t);
        }
        this.dialogVisible4 = true;
        // window.parent.postMessage({ tools: "5" }, "*");
      } else if (t == 6) {
        if (this.noteCount > 0) {
          this.updateCount(this.noteCount, t);
        } else {
          this.noteCount++;
          a = this.noteCount;
          this.toolsCount(a, t);
        }
        window.parent.postMessage({ tools: "6" }, "*");
      } else if (t == 7) {
        if (this.mindNetWorkCount > 0) {
          this.updateCount(this.mindNetWorkCount, t);
        } else {
          this.mindNetWorkCount++;
          a = this.mindNetWorkCount;
          this.toolsCount(a, t);
        }
        window.parent.postMessage({ tools: "7" }, "*");
      } else if (t == 16) {
        if (this.workCount > 0) {
          this.updateCount(this.workCount, t);
        } else {
          this.workCount++;
          a = this.workCount;
          this.toolsCount(a, t);
        }
        this.dialogVisible = true;
      } else if (t == 8) {
        if (this.libraryCount > 0) {
          this.updateCount(this.libraryCount, t);
        } else {
          this.libraryCount++;
          a = this.libraryCount;
          this.toolsCount(a, t);
        }
        window.parent.postMessage({ tools: "8" }, "*");
      } else if (t == 17) {
        if (this.libraryCount > 0) {
          this.updateCount(this.libraryCount, t);
        } else {
          this.libraryCount++;
          a = this.libraryCount;
          this.toolsCount(a, t);
        }
        window.parent.postMessage({ tools: "17" }, "*");
      } else if (t == 18) {
        if (this.trainCount > 0) {
          this.updateCount(this.trainCount, t);
        } else {
          this.trainCount++;
          a = this.trainCount;
          this.toolsCount(a, t);
        }
        window.parent.postMessage({ tools: "18" }, "*");
      } else if (t == 10) {
        if (this.timeCount > 0) {
          this.updateCount(this.timeCount, t);
        } else {
          this.timeCount++;
          a = this.timeCount;
          this.toolsCount(a, t);
        }
        this.timeDialogVisible = true;
      } else if (t == 15) {
        if (this.answerCount > 0) {
          this.updateCount(this.answerCount, t);
        } else {
          this.answerCount++;
          a = this.answerCount;
          this.toolsCount(a, t);
        }
        this.answerQ = this.chapInfo.chapterInfo[0].taskJson[index].toolChoose[
          i
        ].answerQ
          ? this.chapInfo.chapterInfo[0].taskJson[index].toolChoose[i].answerQ
          : "";
        this.answerDialogVisible = true;
      }
    },
    toolsCount(a, t) {
      let params = {
        cid: this.id,
        chid: this.courseType,
        uid: this.userid,
        tid: t,
        count: a,
      };
      this.ajax
        .get(this.$store.state.api + "insertToolsCount", params)
        .then((res) => {
          this.selectCount();
          console.log(res);
        })
        .catch((err) => {
          console.error(err);
        });
    },
    updateCount(c, t) {
      c++;
      let params = {
        cid: this.id,
        chid: this.courseType,
        uid: this.userid,
        tid: t,
        count: c,
      };
      this.ajax
        .get(this.$store.state.api + "updateToolsCount", params)
        .then((res) => {
          this.selectCount();
          console.log(res);
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
  destroyed() {
    window.onresize = null;
  },
  created() {
    this.getCourseDetail();
    this.selectCount();
    this.getHomeWork();
    document.scrollingElement.scrollTop = 0;
    window.addEventListener("resize", () => {
      var a = document.getElementsByClassName("video-player")[0].offsetHeight;
      document.getElementsByClassName("vedioList")[0].style.height = a + "px";
    });
  },
};
</script>

<style scoped>
.body_student {
  width: 77%;
  height: 100%;
  max-height: 800px;
  position: absolute;
  left: 22%;
  top: 0;
}
.student_head {
  width: 100%;
  margin: 0 auto;
  background: #fff;
}

.pb_left {
  width: 20%;
  margin-right: 10px;
  background: rgb(255, 255, 255);
  padding-right: 10px;
  position: fixed;
  height: 100%;
}
.wheel > img,
.project > img,
.star > img,
.evaluate > img,
.up_photo > img,
.chapter_add > img,
.upCover > img,
.deleteWord > img,
.question > img,
.homework > img {
  width: 100%;
  height: 100%;
}
.upCover {
  width: calc(100% / 3.5);
  position: relative;
  margin: 0 15px 10px 0;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-content: center;
  align-items: center;
}
.chapter_add {
  width: 120px;
  position: relative;
  text-align: center;
}
.isAddThings {
  margin-top: 20px;
  position: relative;
  text-align: center;
  background: #f7f8fa;
  height: 90px;
  width: 90px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.deleteWord {
  width: 22px;
  height: 22px;
  position: absolute;
  right: -5px;
  top: -5px;
  cursor: pointer;
}
.box_course {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.wheel {
  width: 70%;
  height: 100%;
}
.right_box {
  display: flex;
  flex-direction: column;
  margin-left: 30px;
  justify-content: space-around;
}
.right_box_title {
  font-size: 23px;
}
.people {
  display: flex;
}
.student_body {
  width: 100%;
  margin: 0 auto;
  margin-top: 20px;
  padding: 0 0 20px;
}
.study_top {
  background: #fff;
  margin: 20px 0 10px 0;
  width: 100%;
}
.study_top .checkbox {
  display: flex;
  align-items: center;
  margin: 0 0 20px 25px;
  padding-top: 20px;
  flex: 0 0 auto;
}
.study_top .check {
  padding-bottom: 5px;
  text-align: center;
  cursor: pointer;
  height: 30px;
  box-sizing: border-box;
  display: flex;
}
.study_top .checked {
  border-bottom: 4px solid #3fc6a0;
  padding-bottom: 5px;
  color: #3fc6a0;
  display: flex;
  height: 35px;
}
.study_top .checked > div,
.study_top .check > div {
  margin-right: 5px;
}
.videoTop {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background: #fff;
  align-items: center;
  width: 95%;
  padding: 20px;
}
.upbtn {
  margin: 25px;
  background: #70afdb;
  color: #fff;
  width: 120px;
  text-align: center;
  height: 30px;
  line-height: 30px;
  font-size: 13px;
  border-radius: 5px;
  cursor: pointer;
}
.project_box {
  background: #fff;
}

.filebox {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  padding: 15px 0;
}

.filebox .tooldetail {
  margin: 0 12px 20px;
}

.file {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 200px;
}

.file div {
  margin-top: 10px;
  width: 150px;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.media {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 20px 20px 0;
  cursor: pointer;
  width: 250px;
  overflow: hidden;
  box-shadow: 0px 1px 3px 0px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%),
    0px 2px 1px -1px rgb(0 0 0 / 12%);
  border-radius: 0 0 5px 5px;
  box-sizing: border-box;
}
.media img {
  width: 250px;
  height: 150px;
  object-fit: cover;
}
.media .title {
  padding: 5px;
  text-align: left;
  width: 100%;
  box-sizing: border-box;
}
.media .btn {
  width: 100%;
  height: 35px;
  line-height: 35px;
  color: #fff;
  background: #606060;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.detail_content_top {
  width: 100%;
  padding: 25px 0 25px 0;
}
.detail_title {
  text-align: center;
  font-size: 24px;
}
.detail_time {
  font-size: 13px;
  padding: 15px 0 0 40px;
}
.detail_content {
  line-height: 2pc;
  width: 90%;
  margin: 0 auto;
  padding-top: 30px;
  text-indent: 30px;
  overflow: auto;
  height: 200px;
}
.score_box >>> .el-rate {
  margin-left: 10px;
}
.dialog_change >>> .el-dialog {
  border-radius: 5px;
}
.dialog_change >>> .el-dialog__header {
  background: #f2f2f2;
  text-align: center;
}
.dialog_change >>> .el-dialog__title {
  line-height: 5px;
}
.dialog_change >>> .el-dialog__body {
  background: #fff;
  padding: 10px 20px;
}
.score_box {
  display: flex;
  align-items: center;
  margin-bottom: 18px;
  margin-top: 20px;
}
.up_photo {
  width: 60px;
  cursor: pointer;
  margin-top: 10px;
}
.upload_send {
  margin: 20px auto;
  width: 60%;
  background: #169bd6;
  text-align: center;
  height: 35px;
  line-height: 35px;
  color: #fff;
  border-radius: 5px;
  cursor: pointer;
}
.marginT {
  margin-top: 20px;
}
.cd_content_steps {
  display: flex;
  width: 90%;
  justify-content: space-around;
  border-top: 1px solid #eeeeee;
}
.cd_steps_box {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
}
.first {
  display: flex;
  align-items: center;
  margin: 15px 0 20px 0;
  font-size: 20px;
}
.first > div:nth-child(2) {
  font-size: 16px !important;
  padding-left: 10px;
  line-height: 26px;
  box-sizing: border-box;
}
.blue_box_one {
  text-align: center;
  color: #fff;
  background-image: linear-gradient(to right, #30c499, #75ceba);
  border-radius: 7px;
  margin: 10px;
  cursor: pointer;
  width: 95%;
  height: 45px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.blue_box_one > div:nth-child(1) {
  line-height: 65px;
  margin: 0 5px 0 10px;
  width: 30%;
  min-width: 70px;
}
.blue_box_one > div:nth-child(2) {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  width: 70%;
  text-align: left;
  max-width: calc(100% - 85px);
}
.blue_box_one > div:nth-child(2):hover {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}
.upFile {
  margin: 0 auto;
  width: 120px;
  background: #70afdb;
  color: #fff;
  height: 30px;
  text-align: center;
  line-height: 30px;
  border-radius: 5px;
  font-size: 14px;
  cursor: pointer;
}
.courseTitle {
  background: #329c74;
  width: 95%;
  margin: 10px auto;
  height: 40px;
  color: #fff;
  line-height: 40px;
  text-indent: 15px;
}
.ml {
  margin-left: 15px;
  color: #d1d1d1;
}
.return {
  width: 2rem;
  height: 2rem;
  cursor: pointer;
}
.return > img {
  width: 100%;
  height: 100%;
}
.returnBtn {
  background: rgb(238, 238, 238);
  width: 58px;
  height: 30px;
  color: rgb(22, 22, 22);
  text-align: center;
  line-height: 32px;
  margin-right: 20px;
  cursor: pointer;
}
.tool {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  width: 13%;
  margin: 0 30px;
  align-items: center;
}
.whiteBIcon {
  width: 150px;
  cursor: pointer;
}
.whiteBIcon > img {
  width: 100%;
  height: 100%;
}
.mask {
  background-color: rgba(0, 0, 0, 0);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 20000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.progressBox {
  width: 500px;
  height: 180px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 0 6px 1px #bfbfbf;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.progressBox .lbox {
  height: 100px;
  font-size: 19px;
  display: flex;
  align-items: center;
}

.progressBox .lbox img {
  width: 40px;
  margin-right: 20px;
}

.progressBox >>> .el-progress-bar__outer {
  background-color: #d1dfff !important;
}
.progressBox .lbox {
  height: 100px;
  font-size: 19px;
  display: flex;
  align-items: center;
}

.progressBox .lbox img {
  width: 40px;
  margin-right: 20px;
}
.uploadVedio {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  margin: 0 15px 10px 0;
}
.uploadVedio > img {
  width: 30px;
  height: 30px;
}
.uploadVedio > span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 75px;
  margin-top: 7px;
}
.picName {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 75px;
  margin-top: 7px;
}
.new_top {
  display: flex;
  background: #fff;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin: 10px 0;
  height: 60px;
  position: relative;
}
.before {
  position: absolute;
  background: #c3dad4;
  width: 6px;
  height: 100%;
}
.courseIndex {
  display: flex;
  flex-direction: row;
  align-items: baseline;
}
.courseIndex > div:nth-child(1) {
  margin: 0 20px;
  padding-bottom: 5px;
  color: #288a6e;
  font-size: 20px;
  width: 80px;
  font-weight: bold;
  border-bottom: 4px solid #41c4a4;
  text-align: center;
}
.courseIndex > div:nth-child(2) {
  font-size: 23px;
  color: #c0c0c0;
}
.course_text {
  padding: 20px 0 0 15px;
  text-indent: 30px;
  width: 80%;
  min-height: 20px;
}
.vedioList {
  background: #f2f2f2;
  width: 200px;
  height: 530px;
  border-radius: 10px;
  overflow: auto;
}
.vedioNav {
  margin: 10px 0 0 15px;
  border-bottom: 1px solid #d7d7d7;
  padding-bottom: 5px;
  background: #d2e3ff;
  width: 60px;
  border-radius: 5px;
  color: #4d97d6;
  text-align: center;
  height: 20px;
  line-height: 26px;
  font-size: 14px;
}
.queTop {
  display: flex;
  padding: 20px 0 20px 15px;
  width: 100%;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 1px solid #eeeeee;
  box-sizing: border-box;
}
.question {
  width: 40px;
  margin-right: 10px;
  margin-top: 7px;
}
.queTitle {
  margin-left: 5px;
  font-size: 25px;
  display: flex;
  align-items: center;
}
.addEditor {
  width: 100px;
  height: 30px;
  background: #42cda6;
  color: #fff;
  border-radius: 5px;
  text-align: center;
  line-height: 30px;
  box-shadow: 1px 3px 6px 1px #bfbfbf;
  cursor: pointer;
}
.vedioName {
  white-space: nowrap;
  overflow: hidden;
  width: 100px;
  text-overflow: ellipsis;
  position: absolute;
  color: #fff;
  bottom: 10px;
  font-size: 14px;
}
.homework {
  width: 200px;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  cursor: pointer;
}
.homebox {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 15px 0;
}
.isChooseActive {
  color: #3e88f4;
  border-bottom: 2px solid #2f80f3;
}
.chooseWho {
  display: flex;
  width: 100%;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  padding-bottom: 10px;
}
.chooseWho > div {
  cursor: pointer;
  padding-bottom: 10px;
  margin: 0 30px;
}
.addPoint > div > img {
  cursor: pointer;
  margin: 0 10px;
  width: 85px;
}
.addPoint > div {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
}
.isBorder > div {
  margin: 0 0 10px 0;
  align-items: flex-start !important;
}
.noiframeBox {
  display: flex;
  flex-wrap: wrap;
}
.iframeBox {
}
.iframeBox iframe {
  width: 100%;
  height: 800px;
  border: none;
  margin-bottom: 20px;
  border: 1px solid #ccc;
}
.upload_toolBtn {
  background: #6b92c9;
  color: #fff;
  width: 110px;
  text-align: center;
  height: 35px;
  line-height: 35px;
  font-size: 14px;
  border-radius: 5px;
  cursor: pointer;
  position: absolute;
  right: 10px;
  bottom: 0;
}

.binfo_input {
  font: inherit;
  color: currentColor;
  width: 100%;
  margin: 0;
  padding: 15px 14px;
  display: block;
  min-width: 0;
  outline: none;
  box-sizing: content-box;
  background: none;
  -webkit-tap-highlight-color: transparent;
  border: 1px solid rgba(0, 0, 0, 0.23);
  border-radius: 4px;
  box-sizing: border-box;
  resize: none;
}

.binfo_input:focus-visible {
  border: 1px solid rgba(61, 103, 188);
}
.dialog_diy >>> .el-dialog__header {
  background: #484848 !important;
  padding: 15px 20px;
}
.dialog_diy >>> .el-dialog__title {
  color: #fff;
}
.dialog_diy >>> .el-dialog__headerbtn {
  top: 19px;
}
.dialog_diy >>> .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}
.dialog_diy >>> .el-dialog__headerbtn .el-dialog__close:hover {
  color: #fff;
}
.dialog_diy >>> .el-dialog__body,
.dialog_diy >>> .el-dialog__footer {
  background: #fafafa;
}
.a_addBox {
  margin: 10px 0;
  background: #fff;
  padding: 15px;
  max-height: 400px;
  overflow: auto;
}
.a_add_box {
  border-bottom: 2px solid #eee;
  padding-bottom: 10px;
}

.a_add_head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 10px 0;
  font-size: 18px;
}
.a_add_head .a_add_head_input {
  width: 300px;
}
.a_add_head .a_add_head_div {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.a_add_body {
  display: flex;
  align-items: center;
}
.a_add_input {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.a_add_input >>> el-radio-group {
  margin: 10px 0;
}
.a_add_input >>> .el-radio {
  margin-bottom: 10px;
}
.redioStyle >>> .el-radio__label {
  font-size: 18px;
}
.toolHeng2 {
  width: 100%;
}
.toolHeng {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}
.toolHeng > div {
  padding-left: 20px;
}
.isWidth {
  width: 20%;
}
.textTitle >>> .el-form-item__label {
  font-size: 20px;
}
.textCss >>> .el-dialog {
  width: 800px !important;
  height: 400px;
  background: #fafafa;
}
.textCss >>> .el-dialog__body {
  margin: 55px 8% 0 8%;
  padding: 0 !important;
}
.textCss >>> .el-dialog__footer {
  padding-top: 38px;
}

.toolsCss >>> .el-dialog__body {
  padding: 20px;
}

.lineCss >>> .el-dialog__body {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.newNav {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: flex-start;
}
.navText {
  cursor: pointer;
  margin: 0px 0px 10px 5px;
  width: 112px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.noVedio {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
}
.noNavText {
  cursor: pointer;
  margin: 0px 0px 10px 5px;
  width: 112px;
}
.listNoVedio {
  margin-top: 10px;
}
.video-player >>> .video-js {
  height: 100%;
}
.hangVedioList {
  width: 95% !important;
  height: 150px !important;
  margin: 0 0 0 20px;
}
.hangVedio {
  align-items: flex-start !important;
}
.hangHand {
  height: 150px !important;
}
.twoChild {
  width: 95%;
  margin: 10px;
  border-radius: 5px;
  background: #f2f2f2;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  transition: all 0.5s;
  overflow: hidden;
  height: 0;
}
.twoChild > div:nth-child(1) {
  margin-top: 5px;
}
.navChild {
  width: 100%;
  cursor: pointer;
  margin-bottom: 10px;
}

.navActive {
  height: auto;
}
.navTask {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  align-content: flex-start;
  height: 40px;
  justify-content: flex-start;
  padding: 0 10px;
  width: 100%;
}
.navTaskname {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  padding-left: 5px;
}
.openTaskActive {
  color: #43a078;
  background: #e8e8e8;
}
.iframeName {
  margin: 5px 0;
  border-left: 4px solid #41c4a4;
  padding-left: 4px;
}
.toolTitle {
  margin: 0px 0px 20px;
  font-size: 20px;
  font-weight: 500;
  border-left: 4px solid #41c4a4;
  padding-left: 4px;
}
.cru_selectBox {
  overflow: auto;
  height: calc(100% - 40px - 21px);
}
.cru_selectBox::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 6px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 6px;
}

/*定义滚动条轨道 内阴影+圆角*/
.cru_selectBox::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: #eee;
}

/*定义滑块 内阴影+圆角*/
.cru_selectBox::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: rgba(0, 0, 0, 0.1);
}
</style>



// WEBPACK FOOTER //
// src/components/study.vue